/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AiAnalysisJobCreateRequest } from '../models/AiAnalysisJobCreateRequest';
import type { AiAnalysisJobCreateResponse } from '../models/AiAnalysisJobCreateResponse';
import type { CancelJobResponse } from '../models/CancelJobResponse';
import type { JobItemListResponse } from '../models/JobItemListResponse';
import type { JobListResponse } from '../models/JobListResponse';
import type { JobResponse } from '../models/JobResponse';
import type { RetryFailedResponse } from '../models/RetryFailedResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class JobsService {
    /**
     * Create Ai Analysis Job
     * AI 분석 작업 등록 (단건: field/report/task, 일괄: workspace/business/department)
     * @returns AiAnalysisJobCreateResponse Accepted
     * @throws ApiError
     */
    public static appsJobsViewsCreateAiAnalysisJob({
        requestBody,
    }: {
        requestBody: AiAnalysisJobCreateRequest,
    }): CancelablePromise<AiAnalysisJobCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/jobs/ai-analysis',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List Jobs
     * 워크스페이스의 작업 목록 (+ 워커 생존 여부)
     * @returns JobListResponse OK
     * @throws ApiError
     */
    public static appsJobsViewsListJobs({
        workspaceId,
        status,
        page = 1,
        perPage = 20,
    }: {
        /**
         * 워크스페이스 ID
         */
        workspaceId: string,
        status?: (string | null),
        page?: number,
        perPage?: number,
    }): CancelablePromise<JobListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/jobs',
            query: {
                'workspace_id': workspaceId,
                'status': status,
                'page': page,
                'per_page': perPage,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Job
     * 작업 상태·진행률 조회 (폴링용)
     * @returns JobResponse OK
     * @throws ApiError
     */
    public static appsJobsViewsGetJob({
        jobId,
    }: {
        jobId: string,
    }): CancelablePromise<JobResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/jobs/{job_id}',
            path: {
                'job_id': jobId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List Job Items
     * 작업 항목 목록 (실패 항목 확인, scope=task 결과 answer 조회)
     * @returns JobItemListResponse OK
     * @throws ApiError
     */
    public static appsJobsViewsListJobItems({
        jobId,
        status,
        page = 1,
        perPage = 50,
    }: {
        jobId: string,
        status?: (string | null),
        page?: number,
        perPage?: number,
    }): CancelablePromise<JobItemListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/jobs/{job_id}/items',
            path: {
                'job_id': jobId,
            },
            query: {
                'status': status,
                'page': page,
                'per_page': perPage,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Cancel Job Endpoint
     * 작업 취소 — 대기 항목은 즉시 취소, 실행 중 항목은 현재 호출 후 중단
     * @returns CancelJobResponse OK
     * @throws ApiError
     */
    public static appsJobsViewsCancelJobEndpoint({
        jobId,
    }: {
        jobId: string,
    }): CancelablePromise<CancelJobResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/jobs/{job_id}/cancel',
            path: {
                'job_id': jobId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Retry Failed Endpoint
     * 실패 항목만 재시도 큐로 복귀
     * @returns RetryFailedResponse OK
     * @throws ApiError
     */
    public static appsJobsViewsRetryFailedEndpoint({
        jobId,
    }: {
        jobId: string,
    }): CancelablePromise<RetryFailedResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/jobs/{job_id}/retry-failed',
            path: {
                'job_id': jobId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
